// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@page {
  size: letter landscape;
  margin: 0.25in;
}
:host {
  display: block;
  min-height: 100vh;
  background: white;
}

.pdf-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  min-height: 52px;
  padding: 8px 16px;
  border-bottom: 0.5px solid #d6d6d6;
  background: #f7f7f7;
}

.pdf-actions {
  display: flex;
  flex-shrink: 0;
  gap: 8px;
}

.pdf-preview {
  display: block;
  width: 100%;
  height: calc(100vh - 53px);
  border: 0;
  background: #525659;
}

.progress-spinner {
  display: flex;
  justify-content: center;
  padding: 48px 0;
}

.message-state {
  padding: 24px;
  color: #666;
}

.container.album {
  box-sizing: border-box;
  width: 8in;
  max-width: 8in;
  margin: 0 auto 30px;
  font-family: sans-serif;
  font-size: 9pt;
}

.worksheet-header {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 10px;
}

.worksheet-header::after {
  content: "";
  flex: 0 0 40px;
}

.worksheet-header .logo {
  width: 40px;
  object-fit: contain;
  flex: 0 0 40px;
}

.worksheet-header > .text-center {
  flex: 1 1 auto;
  min-width: 0;
}

.worksheet-header h2,
.worksheet-header h5 {
  margin: 0;
}

.worksheet-header h2 {
  font-size: 2.25rem;
  font-weight: bold;
}

.worksheet-header h5 {
  font-size: 3.5rem;
  font-weight: normal;
}

.worksheet-details {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 24px;
  margin: 3px 0;
  break-inside: avoid;
}

.worksheet-job-info {
  flex: 0 1 45%;
  min-width: 0;
}

.worksheet-job-info,
.worksheet-request-info {
  margin: 0;
}

.worksheet-field {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  min-height: 1.5em;
}
.worksheet-field dt {
  flex: 0 0 7em;
  font-weight: bold;
  text-align: left;
}
.worksheet-field dd {
  flex: 1 1 auto;
  min-width: 0;
  min-height: 1.5em;
  margin: 0;
  border-bottom: 0.5px solid black;
  text-align: center;
  overflow-wrap: anywhere;
}

.worksheet-summary {
  flex: 0 1 38%;
  min-width: 0;
}

.worksheet-summary-density,
.worksheet-summary-yp {
  min-height: 1.5em;
}

.text-center {
  text-align: center;
}

.text-right {
  text-align: right;
}

.text-left {
  text-align: left;
}

.nobr {
  white-space: nowrap;
}

.wide {
  width: auto;
}

.width100 {
  width: 100%;
}

.width1 {
  width: 1%;
}

.width15 {
  width: 15px;
}

.width20 {
  width: 20px;
}

.width60 {
  width: 60px;
}

.width75 {
  width: 75px;
}

.width100px {
  width: 100px;
}

.worksheet-design-column {
  width: 70px;
  min-width: 70px;
  max-width: 70px;
  box-sizing: border-box;
}

.worksheet-narrow-column {
  width: 70px;
  min-width: 70px;
  max-width: 70px;
  box-sizing: border-box;
  white-space: normal;
  overflow-wrap: anywhere;
  word-break: break-word;
}

table.printable th.worksheet-design-column strong {
  display: block;
  white-space: normal;
  overflow-wrap: anywhere;
  word-break: break-word;
}

.no-border {
  border: 0 !important;
}

.pale {
  background-color: #eeeeee !important;
}

.dark-pale {
  background-color: #feffa4 !important;
}

.light-pale {
  background-color: #feffd8 !important;
}

.divider {
  background-color: #cccccc !important;
}

table.wide {
  width: 730px;
}

.brine-formulation-table {
  width: 320px !important;
  margin-top: 12px !important;
}

table.printable {
  width: auto;
  font-size: 9pt;
  border-spacing: 0;
  border: 0.5px solid black;
  border-collapse: collapse;
  margin: 3px 0;
  page-break-inside: avoid;
}
table.printable th,
table.printable td {
  border-width: 0.5px;
  padding: 0 3px;
  line-height: 1.1;
  border-style: solid;
  border-color: black;
  page-break-inside: avoid;
  height: 20px;
  max-height: 20px;
  vertical-align: middle;
}

.container.album.pdf-capture {
  width: 100%;
  max-width: 100%;
  margin: 0;
  padding: 0;
}
.container.album.pdf-capture * {
  font-size: 6pt;
}
.container.album.pdf-capture h2 {
  font-size: 1rem;
}
.container.album.pdf-capture h5 {
  font-size: 0.8rem;
}
.container.album.pdf-capture .worksheet-details {
  flex-direction: row;
  gap: 24px;
}
.container.album.pdf-capture .dark-pale {
  background-color: #feffa4 !important;
}
.container.album.pdf-capture .light-pale {
  background-color: #feffd8 !important;
}
.container.album.pdf-capture .no-print {
  display: none !important;
}

@media print {
  :host {
    background: white;
  }
  .container.album {
    width: 100%;
    max-width: 100%;
    margin: 0;
    padding: 0;
  }
  .container.album * {
    font-size: 6pt;
  }
  .container.album h2 {
    font-size: 1rem;
  }
  .container.album h5 {
    font-size: 0.8rem;
  }
  .container.album .worksheet-details {
    flex-direction: row;
    gap: 24px;
  }
  .container.album .dark-pale {
    background-color: #feffa4 !important;
  }
  .container.album .light-pale {
    background-color: #feffd8 !important;
  }
  .container.album .no-print {
    display: none !important;
  }
}
:host ::ng-deep table.printable th,
:host ::ng-deep table.printable td,
:host ::ng-deep .container.album table.printable th,
:host ::ng-deep .container.album table.printable td {
  font-size: 6px !important;
}

:host ::ng-deep .next-page,
:host ::ng-deep .nextpage {
  font-size: 10px !important;
}

@media (max-width: 720px) {
  .worksheet-details {
    flex-direction: column;
    gap: 8px;
  }
  .worksheet-job-info,
  .worksheet-summary {
    width: 100%;
  }
  .pdf-toolbar {
    align-items: flex-start;
    flex-direction: column;
  }
  .pdf-preview {
    height: calc(100vh - 105px);
  }
}`, "",{"version":3,"sources":["webpack://./src/app/pages/job-request-work-sheet/job-request-work-sheet.component.scss"],"names":[],"mappings":"AAAA;EACE,sBAAA;EACA,cAAA;AACF;AAEA;EACE,cAAA;EACA,iBAAA;EACA,iBAAA;AAAF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,gBAAA;EACA,iBAAA;EACA,kCAAA;EACA,mBAAA;AAAF;;AAGA;EACE,aAAA;EACA,cAAA;EACA,QAAA;AAAF;;AAGA;EACE,cAAA;EACA,WAAA;EACA,0BAAA;EACA,SAAA;EACA,mBAAA;AAAF;;AAGA;EACE,aAAA;EACA,uBAAA;EACA,eAAA;AAAF;;AAGA;EACE,aAAA;EACA,WAAA;AAAF;;AAGA;EACE,sBAAA;EACA,UAAA;EACA,cAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AAAF;;AAGA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AAAF;;AAGA;EACE,WAAA;EACA,cAAA;AAAF;;AAGA;EACE,WAAA;EACA,mBAAA;EACA,cAAA;AAAF;;AAGA;EACE,cAAA;EACA,YAAA;AAAF;;AAGA;;EAEE,SAAA;AAAF;;AAGA;EACE,kBAAA;EACA,iBAAA;AAAF;;AAGA;EACE,iBAAA;EACA,mBAAA;AAAF;;AAGA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;EACA,aAAA;EACA,mBAAA;AAAF;;AAGA;EACE,aAAA;EACA,YAAA;AAAF;;AAGA;;EAEE,SAAA;AAAF;;AAGA;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,iBAAA;AAAF;AAEE;EACE,aAAA;EACA,iBAAA;EACA,gBAAA;AAAJ;AAGE;EACE,cAAA;EACA,YAAA;EACA,iBAAA;EACA,SAAA;EACA,gCAAA;EACA,kBAAA;EACA,uBAAA;AADJ;;AAKA;EACE,aAAA;EACA,YAAA;AAFF;;AAKA;;EAEE,iBAAA;AAFF;;AAKA;EAAe,kBAAA;AADf;;AAEA;EAAc,iBAAA;AAEd;;AADA;EAAa,gBAAA;AAKb;;AAJA;EAAQ,mBAAA;AAQR;;AAPA;EAAQ,WAAA;AAWR;;AAVA;EAAY,WAAA;AAcZ;;AAbA;EAAU,SAAA;AAiBV;;AAhBA;EAAW,WAAA;AAoBX;;AAnBA;EAAW,WAAA;AAuBX;;AAtBA;EAAW,WAAA;AA0BX;;AAzBA;EAAW,WAAA;AA6BX;;AA5BA;EAAc,YAAA;AAgCd;;AA/BA;EACE,WAAA;EACA,eAAA;EACA,eAAA;EACA,sBAAA;AAkCF;;AA/BA;EACE,WAAA;EACA,eAAA;EACA,eAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;AAkCF;;AA/BA;EACE,cAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;AAkCF;;AA/BA;EAAa,oBAAA;AAmCb;;AAlCA;EAAQ,oCAAA;AAsCR;;AArCA;EAAa,oCAAA;AAyCb;;AAxCA;EAAc,oCAAA;AA4Cd;;AA3CA;EAAW,oCAAA;AA+CX;;AA7CA;EAAa,YAAA;AAiDb;;AA/CA;EACE,uBAAA;EACA,2BAAA;AAkDF;;AA/CA;EACE,WAAA;EACA,cAAA;EACA,iBAAA;EACA,yBAAA;EACA,yBAAA;EACA,aAAA;EACA,wBAAA;AAkDF;AAhDE;;EAEE,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,wBAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;AAkDJ;;AA5BA;EAjBE,WAAA;EACA,eAAA;EACA,SAAA;EACA,UAAA;AAiDF;AA/CE;EAAM,cAAA;AAkDR;AAjDE;EAAO,eAAA;AAoDT;AAnDE;EAAO,iBAAA;AAsDT;AArDE;EACE,mBAAA;EACA,SAAA;AAuDJ;AArDE;EAAe,oCAAA;AAwDjB;AAvDE;EAAgB,oCAAA;AA0DlB;AAzDE;EAAc,wBAAA;AA4DhB;;AArDA;EACE;IAAQ,iBAAA;EAyDR;EAvDA;IAxBA,WAAA;IACA,eAAA;IACA,SAAA;IACA,UAAA;EAkFA;EAhFA;IAAM,cAAA;EAmFN;EAlFA;IAAO,eAAA;EAqFP;EApFA;IAAO,iBAAA;EAuFP;EAtFA;IACE,mBAAA;IACA,SAAA;EAwFF;EAtFA;IAAe,oCAAA;EAyFf;EAxFA;IAAgB,oCAAA;EA2FhB;EA1FA;IAAc,wBAAA;EA6Fd;AACF;AA9EA;;;;EAIE,yBAAA;AAgFF;;AA7EA;;EAEE,0BAAA;AAgFF;;AA7EA;EACE;IACE,sBAAA;IACA,QAAA;EAgFF;EA7EA;;IAEE,WAAA;EA+EF;EA5EA;IACE,uBAAA;IACA,sBAAA;EA8EF;EA3EA;IACE,2BAAA;EA6EF;AACF","sourcesContent":["@page {\n  size: letter landscape;\n  margin: 0.25in;\n}\n\n:host {\n  display: block;\n  min-height: 100vh;\n  background: white;\n}\n\n.pdf-toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  min-height: 52px;\n  padding: 8px 16px;\n  border-bottom: 0.5px solid #d6d6d6;\n  background: #f7f7f7;\n}\n\n.pdf-actions {\n  display: flex;\n  flex-shrink: 0;\n  gap: 8px;\n}\n\n.pdf-preview {\n  display: block;\n  width: 100%;\n  height: calc(100vh - 53px);\n  border: 0;\n  background: #525659;\n}\n\n.progress-spinner {\n  display: flex;\n  justify-content: center;\n  padding: 48px 0;\n}\n\n.message-state {\n  padding: 24px;\n  color: #666;\n}\n\n.container.album {\n  box-sizing: border-box;\n  width: 8in;\n  max-width: 8in;\n  margin: 0 auto 30px;\n  font-family: sans-serif;\n  font-size: 9pt;\n}\n\n.worksheet-header {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  margin-bottom: 10px;\n}\n\n.worksheet-header::after {\n  content: '';\n  flex: 0 0 40px;\n}\n\n.worksheet-header .logo {\n  width: 40px;\n  object-fit: contain;\n  flex: 0 0 40px;\n}\n\n.worksheet-header > .text-center {\n  flex: 1 1 auto;\n  min-width: 0;\n}\n\n.worksheet-header h2,\n.worksheet-header h5 {\n  margin: 0;\n}\n\n.worksheet-header h2 {\n  font-size: 2.25rem;\n  font-weight: bold;\n}\n\n.worksheet-header h5 {\n  font-size: 3.5rem;\n  font-weight: normal;\n}\n\n.worksheet-details {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 24px;\n  margin: 3px 0;\n  break-inside: avoid;\n}\n\n.worksheet-job-info {\n  flex: 0 1 45%;\n  min-width: 0;\n}\n\n.worksheet-job-info,\n.worksheet-request-info {\n  margin: 0;\n}\n\n.worksheet-field {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  min-height: 1.5em;\n\n  dt {\n    flex: 0 0 7em;\n    font-weight: bold;\n    text-align: left;\n  }\n\n  dd {\n    flex: 1 1 auto;\n    min-width: 0;\n    min-height: 1.5em;\n    margin: 0;\n    border-bottom: 0.5px solid black;\n    text-align: center;\n    overflow-wrap: anywhere;\n  }\n}\n\n.worksheet-summary {\n  flex: 0 1 38%;\n  min-width: 0;\n}\n\n.worksheet-summary-density,\n.worksheet-summary-yp {\n  min-height: 1.5em;\n}\n\n.text-center { text-align: center; }\n.text-right { text-align: right; }\n.text-left { text-align: left; }\n.nobr { white-space: nowrap; }\n.wide { width: auto; }\n.width100 { width: 100%; }\n.width1 { width: 1%; }\n.width15 { width: 15px; }\n.width20 { width: 20px; }\n.width60 { width: 60px; }\n.width75 { width: 75px; }\n.width100px { width: 100px; }\n.worksheet-design-column {\n  width: 70px;\n  min-width: 70px;\n  max-width: 70px;\n  box-sizing: border-box;\n}\n\n.worksheet-narrow-column {\n  width: 70px;\n  min-width: 70px;\n  max-width: 70px;\n  box-sizing: border-box;\n  white-space: normal;\n  overflow-wrap: anywhere;\n  word-break: break-word;\n}\n\ntable.printable th.worksheet-design-column strong {\n  display: block;\n  white-space: normal;\n  overflow-wrap: anywhere;\n  word-break: break-word;\n}\n\n.no-border { border: 0 !important; }\n.pale { background-color: #eeeeee !important; }\n.dark-pale { background-color: #feffa4 !important; }\n.light-pale { background-color: #feffd8 !important; }\n.divider { background-color: #cccccc !important; }\n\ntable.wide { width: 730px; }\n\n.brine-formulation-table {\n  width: 320px !important;\n  margin-top: 12px !important;\n}\n\ntable.printable {\n  width: auto;\n  font-size: 9pt;\n  border-spacing: 0;\n  border: 0.5px solid black;\n  border-collapse: collapse;\n  margin: 3px 0;\n  page-break-inside: avoid;\n\n  th,\n  td {\n    border-width: 0.5px;\n    padding: 0 3px;\n    line-height: 1.1;\n    border-style: solid;\n    border-color: black;\n    page-break-inside: avoid;\n    height: 20px;\n    max-height: 20px;\n    vertical-align: middle;\n  }\n}\n\n@mixin worksheet-print-layout {\n  width: 100%;\n  max-width: 100%;\n  margin: 0;\n  padding: 0;\n\n  & * { font-size: 6pt; }\n  & h2 { font-size: 1rem; }\n  & h5 { font-size: 0.8rem; }\n  & .worksheet-details {\n    flex-direction: row;\n    gap: 24px;\n  }\n  & .dark-pale { background-color: #feffa4 !important; }\n  & .light-pale { background-color: #feffd8 !important; }\n  & .no-print { display: none !important; }\n}\n\n.container.album.pdf-capture {\n  @include worksheet-print-layout;\n}\n\n@media print {\n  :host { background: white; }\n\n  .container.album {\n    @include worksheet-print-layout;\n  }\n\n}\n\n:host ::ng-deep table.printable th,\n:host ::ng-deep table.printable td,\n:host ::ng-deep .container.album table.printable th,\n:host ::ng-deep .container.album table.printable td {\n  font-size: 6px !important;\n}\n\n:host ::ng-deep .next-page,\n:host ::ng-deep .nextpage {\n  font-size: 10px !important;\n}\n\n@media (max-width: 720px) {\n  .worksheet-details {\n    flex-direction: column;\n    gap: 8px;\n  }\n\n  .worksheet-job-info,\n  .worksheet-summary {\n    width: 100%;\n  }\n\n  .pdf-toolbar {\n    align-items: flex-start;\n    flex-direction: column;\n  }\n\n  .pdf-preview {\n    height: calc(100vh - 105px);\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
